import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Loading.module.css';
export default function Loading(_a) {
    var className = _a.className;
    return (_jsx("div", { className: "".concat(className, " ").concat(styles.loadingContainer), "data-testid": "load", children: _jsxs("div", { className: styles.loading, children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {})] }) }));
}
